import { Loader, Select } from '@mantine/core';
import { useEffect, useState } from 'react';
import { ContactProjection, ContactS } from '../../../Service/ContactS';

type Props = {
  entityType?: string;
  eventId?: string | null;
  value: string | null;
  onChange: (value: string | null) => void;
};

const TaskContactSelect = ({ entityType, eventId, value, onChange }: Props) => {
  const [contacts, setContacts] = useState<ContactProjection[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let active = true;

    const fetchContacts = async () => {
      setContacts([]);

      if (entityType !== 'profiles' && (entityType !== 'events' || !eventId)) {
        setLoading(false);
        return;
      }

      setLoading(true);

      try {
        const fetchedContacts =
          entityType === 'events'
            ? await ContactS.getEventContacts(eventId as string)
            : await ContactS.fetchAllOptions();

        if (active) {
          setContacts(fetchedContacts);
        }
      } catch {
        if (active) {
          setContacts([]);
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    fetchContacts();

    return () => {
      active = false;
    };
  }, [entityType, eventId]);

  return (
    <Select
      clearable
      searchable
      disabled={loading || (entityType !== 'profiles' && (entityType !== 'events' || !eventId))}
      value={value}
      onChange={onChange}
      data={contacts.map((contact) => ({
        value: contact.id.toString(),
        label: contact.personDescription,
      }))}
      description="Kontakt"
      placeholder={loading ? 'Kontakte werden geladen ...' : 'Kontakt auswählen'}
      nothingFound="Keine Kontakte gefunden"
      rightSection={loading ? <Loader size="xs" /> : undefined}
      maxDropdownHeight={280}
      sx={{ marginBottom: 10 }}
    />
  );
};

export default TaskContactSelect;
